import React, { useState, useEffect, useRef } from 'react';

import css from './ProgressLoader.module.scss';

interface Props {
  liveStreamIsBusy?: boolean;
  hideProgress: () => void;
}

const ProgressLoader: React.FC<Props> = ({ liveStreamIsBusy, hideProgress }) => {
  const [percents, setPercents] = useState<number>(0);
  const intervalRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    let progress = 0;
    const intervalId = setInterval(() => {
      progress = progress + 1;
      setPercents(progress);
      if (progress === 100) {
        clearInterval(intervalRef.current);
      }
    }, 300);
    intervalRef.current = intervalId;

    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

  useEffect(() => {
    if (!liveStreamIsBusy) {
      setPercents(100);
      setTimeout(() => {
        hideProgress();
      }, 100);
      clearInterval(intervalRef.current);
    }
  }, [liveStreamIsBusy]);

  return (
    <div className={css.progressLoader}>
      <div className={css.inner} style={{ width: `${percents}%` }}></div>
    </div>
  );
};

export default ProgressLoader;
